module.exports = __webpack_public_path__ + "static/media/dispatch_center.3199f819.jpg";